// @ts-ignore
import { createContext, PropsWithChildren, useCallback, useContext, useEffect, useRef, useState } from "react";

import { useAPI } from ".";
import { Status } from "psims/types/async";
import { Dashboard, isDashboard } from "psims/models/dashboard";
import { DataSubmissionVM } from "psims/gen/xapi-client/models/DataSubmissionVM";

type DashboardContext = {
    refetch: () => void;
    status: Status;
    dashboard: Dashboard | null;
    msoImporterWeekly: DataSubmissionVM[] | null
    msoRefinerW: DataSubmissionVM[] | null
}

const context = createContext<DashboardContext | null>(null);

const DashboardProvider = ({children}: PropsWithChildren<{}>) => {
    const {api} = useAPI();
    const [dashboard, setDashboard] = useState<Dashboard | null>(null);
    const [msoImporterWeekly, setMsoImporterWeekly] = useState<DataSubmissionVM[] | null>(null);
    const [msoRefinerW, setMsoRefinerW] = useState<DataSubmissionVM[] | null>(null);
    const [status, setStatus] = useState<Status>('init');
    // Quick-and-dirty ad-hoc debounce - probably should hookify if needed elsewhere
    const debouncedId = useRef<number | null>(null);

    const fetch = useCallback(() => {
        if (debouncedId.current != null) {
            return;
        }

        setStatus('loading');

        debouncedId.current = window.setTimeout(() => debouncedId.current = null, 100);

        api.getDashboard()
        .then(response => {
            if (response?.isSuccessful && isDashboard(response.result)) {
        
                setDashboard({
                    ...response.result,
                    dataSubmissions: [
                        ...(response.result.dataSubmissions || []),
                    ]
                });
                setMsoImporterWeekly(
                    
                        ((response.result.dataSubmissions)?.filter((msi) => ((msi.submissionTypeId === 7) && (msi.reportFrequencyTypeId === 6) )).sort((a, b) => b!.id! - a!.id!) || [])
                    
                )
                  setMsoRefinerW(
                    
                        ((response.result.dataSubmissions)?.filter((msi) => ((msi.submissionTypeId === 8) && (msi.reportFrequencyTypeId === 6) )).sort((a, b) => b!.id! - a!.id!) || [])
                    
                )
                setStatus('fulfilled');
            } else {
                setStatus('error');
            }
        })
        .catch(() => {
            setStatus('error');
        });
    }, [api]);

    useEffect(() => {
        if (dashboard !== null) {
            return;
        }

        fetch();
    }, [dashboard, fetch]);

    return <context.Provider value={{dashboard, msoImporterWeekly, msoRefinerW, status, refetch: fetch}}>
        {children}
    </context.Provider>
}

export default DashboardProvider;

export function useDashboard() {
    const ctx = useContext(context);

    if (ctx === null) {
        throw new Error('useDashboard must be used within DashboardProvider');
    }

    return {
        ...ctx,
    };
}
